import { useState, useEffect } from 'react';
import { useAppContext } from '../context/AppContext';
import { fetchPodData } from '../utils/api';

/**
 * Custom hook for managing pod data
 * Provides easy access to pod data with loading states and error handling
 */
export const usePodData = () => {
  const { podData, setPodData, setLoading, setError } = useAppContext();
  const [isLoadingPod, setIsLoadingPod] = useState(false);
  const [podError, setPodError] = useState(null);


  /**
   * Fetch pod data from API by IP address
   * @param {string} ipAddress - IP address to fetch pod data for
   */
  const loadPodData = async (ipAddress, silent = false) => {
    try {
      if (!silent) {
        setIsLoadingPod(true);
      }
      setPodError(null);
      setLoading(true);

      const data = await fetchPodData(ipAddress);
      setPodData(data);

      return data;
    } catch (error) {
      setPodError(error.message || 'Failed to load pod data');
      setError(error.message || 'Failed to load pod data');
      // throw error;
    } finally {
      if (!silent) {
        setIsLoadingPod(false);
      }
      setLoading(false);
    }
  };

  /**
   * Refresh pod data
   * @param {string} ipAddress - IP address to fetch pod data for
   */
  const refreshPodData = async (ipAddress) => {
    return await loadPodData(ipAddress, true);
  };

  /**
   * Clear pod data
   */
  const clearPodData = () => {
    setPodData(null);
    setPodError(null);
  };

  return {
    podData,
    isLoadingPod,
    podError,
    loadPodData,
    refreshPodData,
    clearPodData,
  };
};
